export const selectSx = {
	color: '#E0E7FF',
	fontSize: 13,
	'& .MuiOutlinedInput-notchedOutline': { borderColor: '#1E3A5F' },
	'&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#4FC3F7' },
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4FC3F7' },
	'& .MuiSvgIcon-root': { color: '#90A4AE' },
	backgroundColor: '#060F1A',
};

export const menuSx = {
	PaperProps: {
		sx: {
			backgroundColor: '#0D1B2A', color: '#E0E7FF', maxHeight: 260,
			border: '1px solid #1E3A5F',
			'&::-webkit-scrollbar': { width: 4 },
			'&::-webkit-scrollbar-thumb': { background: '#1E3A5F', borderRadius: 2 },
		},
	},
};

export const inputSx = {
	'& .MuiOutlinedInput-root': {
		color: '#E0E7FF', borderRadius: 1.5, fontSize: 13,
		'& fieldset': { borderColor: '#1E3A5F' },
		'&:hover fieldset': { borderColor: '#4FC3F7' },
		'&.Mui-focused fieldset': { borderColor: '#4FC3F7' },
		backgroundColor: '#060F1A',
	},
};